export const ProfileInformation= {
    address: 'Euro Store 778 Bahria, Sector Bb Block Sector D Town, Lahore',
    phoneNumber: '03214264000',
    country: 'Pakistan',
    instagram: 'https://www.instagram.com/mdpharmacy.pk/',
    facebook: 'https://www.facebook.com/profile.php?id=61579143991452',
    email: "muhammaddinpharmacy@gmail.com",
    twitter: 'https://twitter.com/',
}